export default __webpack_public_path__ + "static/other-services-f6046083cac2d7d45afeb2847e358590.png";